import { useEffect, useRef, useState } from "react";
import Header from "../../Header";
import PageTransition from "../../../PageTransition";
import "../Branding.css";
import { Helmet } from "react-helmet-async";
import morecardimg from '../../../assets/more-card-img.png'
import fsielogo from '../../../assets/fsie-logo.webp'
import fsiepdf from '../../../assets/fsie.pdf'

/* ================= DATA ================= */
const SEO_WORKS = [
  {
    title: "FSIE",
    desc: "Fire & Security India Expo",
    image: fsielogo,
    pdf: fsiepdf,
  },
  {
    image: morecardimg,
    comingSoon: true
  }
];

/* ================= RESPONSIVE COUNT ================= */
const getVisible = () => {
  if (window.innerWidth <= 768) return 1; // mobile
  return 2; // desktop & tablet (ONLY TWO)
};

export default function SeoGeo() {
  const sliderRef = useRef(null);

  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(getVisible());
  const [hint, setHint] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const isAnimating = useRef(false);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const touchStartX = useRef(0);

  const maxIndex = SEO_WORKS.length - visible;

  /* ================= RESET ================= */
  useEffect(() => {
    document.body.style.overflow = "auto";
    window.scrollTo(0, 0);
  }, []);

  /* ================= RESIZE ================= */
  useEffect(() => {
    const onResize = () => {
      const v = getVisible();
      setVisible(v);
      setIsMobile(window.innerWidth <= 768);
      setIndex((i) => Math.min(i, SEO_WORKS.length - v));
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  /* ================= WHEEL (DESKTOP) ================= */
  useEffect(() => {
    if (isMobile) return;

    const onWheel = (e) => {
      e.preventDefault();
      if (isAnimating.current) return;

      if (e.deltaY > 0 && index < maxIndex) slideTo(index + 1);
      if (e.deltaY < 0 && index > 0) slideTo(index - 1);
    };

    window.addEventListener("wheel", onWheel, { passive: false });
    return () => window.removeEventListener("wheel", onWheel);
  }, [index, maxIndex, isMobile]);

  /* ================= CURSOR HINT ================= */
  useEffect(() => {
    if (isMobile) return;

    const move = (e) => {
      if (!sliderRef.current) return;
      const r = sliderRef.current.getBoundingClientRect();
      setHint(e.clientX > r.left + r.width / 2 ? "right" : "left");
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [isMobile]);

  /* ================= MOUSE DRAG ================= */
  const onMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.clientX;
  };

  const onMouseMove = (e) => {
    if (!isDragging.current || isAnimating.current) return;

    const delta = e.clientX - startX.current;
    if (delta > 80 && index > 0) {
      slideTo(index - 1);
      isDragging.current = false;
    }
    if (delta < -80 && index < maxIndex) {
      slideTo(index + 1);
      isDragging.current = false;
    }
  };

  const onMouseUp = () => {
    isDragging.current = false;
  };

  /* ================= TOUCH ================= */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) < 60) return;

    if (delta < 0 && index < maxIndex) slideTo(index + 1);
    if (delta > 0 && index > 0) slideTo(index - 1);
  };

  /* ================= TAP ================= */
  const onClickSlide = (e) => {
    if (isMobile || isAnimating.current) return;

    const r = sliderRef.current.getBoundingClientRect();
    const mid = r.left + r.width / 2;

    if (e.clientX > mid && index < maxIndex) slideTo(index + 1);
    if (e.clientX < mid && index > 0) slideTo(index - 1);
  };

  /* ================= TOUCH MOVE ================= */
  const onTouchMove = (e) => {
    if (isAnimating.current) return;
    const touchX = e.touches[0].clientX;
    const delta = touchX - touchStartX.current;
    if (Math.abs(delta) < 30) return;
    if (delta < 0 && index < maxIndex) {
      slideTo(index + 1);
      touchStartX.current = touchX;
    }
    if (delta > 0 && index > 0) {
      slideTo(index - 1);
      touchStartX.current = touchX;
    }
  };

  /* ================= SLIDE ================= */
  const slideTo = (i) => {
    isAnimating.current = true;
    setIndex(i);
    setTimeout(() => (isAnimating.current = false), 700);
  };

  
  return (
    <>




    <>
      <Helmet>
        
        <title> SEO & GEO Services | AI Search Optimization Agency | 2 Light Years        </title>

        <meta name="description"content="Boost online visibility with SEO and GEO services. Get found on Google, ChatGPT, Gemini, Perplexity, and AI search engines with 2 Light Years."/>

        <meta name="robots"  content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"  />

        <meta name="keywords" content="" />

       
        <link rel="canonical"href="https://2lightyears.com/seo-geo" />

        
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />

      
        <meta property="og:type"content="website"  />

        <meta property="og:title"content="SEO & GEO Services | AI Search Optimization Agency"        />

        <meta property="og:description" content="Improve visibility on Google and AI search engines like ChatGPT, Gemini, Claude & Perplexity with advanced SEO + GEO optimization."        />

        <meta property="og:url" content="https://2lightyears.com/seo-geo" />

        <meta property="og:site_name" content="2 Light Years" />

        <meta property="og:image" content="https://2lightyears.com/static/media/quick-fixes-to-improve-website-speed-and-user-engagement-main.d85a0be639df0cad1ac4.webp"  />

        <meta
property="og:image:alt"content="SEO GEO Services by 2 Light Years"        />

        
        <meta name="twitter:card" content="summary_large_image"        />

        <meta name="twitter:title"content="SEO & GEO Services | AI Search Optimization"         />

        <meta name="twitter:description"content="Rank on Google and AI search platforms like ChatGPT, Gemini, Claude & Perplexity with SEO + GEO optimization."  />

        <meta name="twitter:image" content="https://2lightyears.com/static/media/quick-fixes-to-improve-website-speed-and-user-engagement-main.d85a0be639df0cad1ac4.webp"
        />

        <meta name="viewport" content="width=device-width, initial-scale=1"        />


        <script type="application/ld+json">
        </script>
      </Helmet>
    </>
 



      <Header visible mode="normal" />

      

      <PageTransition>

        
        <main className="branding-page" style={{ marginTop: isMobile ? "8rem" : "12rem" }}>
          {/* ================= HERO ================= */}
          <section className="branding-hero">
            <h1>SEO & GEO</h1>
            <p>
              We Optimize Your Digital Presence For Both Traditional Search Engines
              And AI-Powered Generative Engines To Ensure Your Brand Is Discoverable Everywhere.
            </p>
          </section>

          {/* ================= SLIDER ================= */}
          <div
            ref={sliderRef}
            className="branding-slider"
            onClick={onClickSlide}
            onMouseDown={!isMobile ? onMouseDown : undefined}
            onMouseMove={!isMobile ? onMouseMove : undefined}
            onMouseUp={!isMobile ? onMouseUp : undefined}
            onMouseLeave={!isMobile ? onMouseUp : undefined}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <div
              className="branding-track"
              style={{
                transform: `translateX(-${index * (100 / visible)}%)`,
              }}
            >
              {SEO_WORKS.map((item, i) => (
                <div className="branding-card" key={i}>
                  <div
                    className="branding-image"
                    style={{ backgroundImage: `url(${item.image})` }}
                  />

                  {item.title && item.pdf && (
                    <button
                      className="branding-cta"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(item.pdf, "_blank", "noopener,noreferrer");
                      }}
                    >
                      {item.title}
                    </button>
                  )}

                  {item.desc && <span>{item.desc}</span>}
                </div>
              ))}
            </div>
          </div>
        </main>
      </PageTransition>
    </>
  );
}
